import { render, staticRenderFns } from "./AudioIcon.vue?vue&type=template&id=b7e95376&scoped=true&"
import script from "./AudioIcon.vue?vue&type=script&lang=js&"
export * from "./AudioIcon.vue?vue&type=script&lang=js&"
import style0 from "./AudioIcon.vue?vue&type=style&index=0&id=b7e95376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e95376",
  null
  
)

export default component.exports